import React, { useContext, useState, useRef, useEffect } from "react"
import { Main, Wrapper, TitleBox } from "./style"
import SingleAgent from "./SingleAgent"
import karolina from "../../../images/karolina.jpg"
import rafal from "../../../images/rafal.jpg"
import joanna from "../../../images/joanna.jpg"
import kamil from "../../../images/kamil.jpg"
import artem from "../../../images/artem.jpg"
import dajana from "../../../images/dajana.png"
import michal from "../../../images/michal.png"
import { ResolutionContext } from "../../../contexts/ResolutionContext"
import PopUp from "../../PopUp"
import { FakeScrollBox } from "../../OfferPage/FlatDescription/style"

const OurAgentsComponent = ({ our_agents }) => {
  const isBrowser = typeof window !== "undefined"
  const [isTablet, isTabletAndPhone, isPhone] = useContext(ResolutionContext)
  const [isOpen, toggleOpen] = useState(false)
  const [selectedAgentEmail, setSelectedAgentEmail] = useState(null)
  const scrollRef = useRef(null)

  useEffect(() => {
    if (window.location.hash === "#agents" && isBrowser) {
      setTimeout(() => {
        scrollRef.current.scrollIntoView(true)
      }, 0)
    }
  }, [])

  return (
    <Main>
      <FakeScrollBox ref={scrollRef} />
      <PopUp
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        agentEmail={selectedAgentEmail}
      />
      <TitleBox>
        <h3>{our_agents}</h3>
      </TitleBox>
      <Wrapper>
        <SingleAgent
          image={karolina}
          name="Karolina Borowska-Dębosz"
          phone="+48 535 573 640"
          email="karolina@debosz.com.pl"
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
        />

        <SingleAgent
          image={rafal}
          name="Rafał Dębosz"
          phone="+48 503 047 223"
          email="rafal@debosz.com.pl"
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
        />
      </Wrapper>
      <Wrapper>
        <SingleAgent
          image={joanna}
          name="Joanna Raj"
          phone="+48 530 641 969"
          email="joanna.raj@debosz.com.pl"
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
        />

        <SingleAgent
          image={artem}
          name="Artem Dudnyk"
          phone="+48 575 365 530"
          email="artem@debosz.com.pl"
          toggleOpen={toggleOpen}
          ua={true}
          fn={setSelectedAgentEmail}
        />
        <SingleAgent
          image={dajana}
          name="Dajana Fernandez"
          phone="+48 690 821 599"
          email="dajana.fernandez@debosz.com.pl"
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
          goldBackground={false}
        />
        <SingleAgent
          image={michal}
          name="Michał Woźniak"
          phone="+48 575 337 169"
          email="michal.wozniak@debosz.com.pl"
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
          goldBackground={false}
        />
        <SingleAgent
          image={kamil}
          name="Kamil Sowiński"
          phone=""
          email=""
          toggleOpen={toggleOpen}
          fn={setSelectedAgentEmail}
        />
      </Wrapper>
    </Main>
  )
}

export default OurAgentsComponent
